import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header-content" }
const _hoisted_2 = { class: "header-actions" }
const _hoisted_3 = {
  key: 0,
  class: "user-menu"
}
const _hoisted_4 = { class: "welcome-text" }
const _hoisted_5 = { class: "user-avatar-container" }
const _hoisted_6 = {
  key: 1,
  class: "guest-actions"
}

import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import {
  User,
  SwitchButton,
  Document,
  Plus,
  ArrowDown,
  Lock,
  UserFilled,
} from '@element-plus/icons-vue';
import { ElMessageBox } from 'element-plus';
import { useAuthStore } from '@/stores/auth';


export default /*@__PURE__*/_defineComponent({
  __name: 'PageHeader',
  setup(__props) {

const authStore = useAuthStore();
const router = useRouter();
const isScrolled = ref(false);

// Generate avatar URL based on user initials or use default
const userAvatarUrl = computed(() => {
  if (!authStore.user) {
    return '';
  }
  // Using DiceBear API for consistent avatars
  return `https://api.dicebear.com/7.x/initials/svg?seed=${authStore.userDisplayName}&backgroundColor=aa947a&textColor=ffffff`;
});

const handleScroll = () => {
  isScrolled.value = window.scrollY > 10;
};

const goToMyRecipes = () => {
  router.push({ name: 'home', query: { filter: 'my-recipes' } });
};

const goToCreateRecipe = () => {
  router.push('/create');
};

const handleLogout = async () => {
  try {
    await ElMessageBox.confirm(
      'Are you sure you want to logout?',
      'Confirm Logout',
      {
        confirmButtonText: 'Yes, Logout',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }
    );

    authStore.logout();
    router.push('/');
  } catch {
    // User cancelled logout
  }
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header", { 'header-scrolled': isScrolled.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo-link"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createElementVNode("h1", null, "🍳 Recipe Vault", -1)
        ])),
        _: 1,
        __: [2]
      }),
      _createElementVNode("div", _hoisted_2, [
        (_unref(authStore).isAuthenticated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, "Hello, " + _toDisplayString(_unref(authStore).userDisplayName) + "!", 1),
              _createVNode(_component_el_dropdown, {
                trigger: "hover",
                placement: "bottom-end"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, { onClick: goToMyRecipes }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Document), { class: "dropdown-icon" }),
                          _cache[3] || (_cache[3] = _createTextVNode(" My Recipes "))
                        ]),
                        _: 1,
                        __: [3]
                      }),
                      _createVNode(_component_el_dropdown_item, { onClick: goToCreateRecipe }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Plus), { class: "dropdown-icon" }),
                          _cache[4] || (_cache[4] = _createTextVNode(" Create Recipe "))
                        ]),
                        _: 1,
                        __: [4]
                      }),
                      _createVNode(_component_el_dropdown_item, { divided: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(User), { class: "dropdown-icon" }),
                          _cache[5] || (_cache[5] = _createTextVNode(" Profile Settings "))
                        ]),
                        _: 1,
                        __: [5]
                      }),
                      _createVNode(_component_el_dropdown_item, { onClick: handleLogout }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(SwitchButton), { class: "dropdown-icon" }),
                          _cache[6] || (_cache[6] = _createTextVNode(" Logout "))
                        ]),
                        _: 1,
                        __: [6]
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_el_avatar, {
                      class: "user-avatar",
                      size: 40,
                      src: userAvatarUrl.value,
                      alt: _unref(authStore).userDisplayName
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(authStore).userInitials), 1)
                      ]),
                      _: 1
                    }, 8, ["src", "alt"]),
                    _createVNode(_component_el_icon, { class: "dropdown-arrow" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowDown))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_el_button, {
                class: "custom-button-secondary header-btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/login')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Lock), { class: "button-icon" }),
                  _cache[7] || (_cache[7] = _createTextVNode(" Sign In "))
                ]),
                _: 1,
                __: [7]
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                class: "custom-button header-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/register')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(UserFilled), { class: "button-icon" }),
                  _cache[8] || (_cache[8] = _createTextVNode(" Sign Up "))
                ]),
                _: 1,
                __: [8]
              })
            ]))
      ])
    ])
  ], 2))
}
}

})